var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import units from '../theme/units';
var useStyles = makeStyles(function (theme) { return ({
    root: {
        zIndex: 1,
        '&$expanded': {
            zIndex: 1,
            marginTop: 0,
            backgroundColor: theme.palette.grey[50],
        },
    },
    expanded: {},
    content: {
        zIndex: 1,
    },
    withMargin: {
        margin: units.trbl(1.25, 0, 1.25, 0),
    },
}); });
var Expandable = function (_a) {
    var _b;
    var summary = _a.summary, details = _a.details, expanded = _a.expanded, elevation = _a.elevation, square = _a.square, onChange = _a.onChange, panelStyle = _a.panelStyle, detailsClassname = _a.detailsClassname, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, rest = __rest(_a, ["summary", "details", "expanded", "elevation", "square", "onChange", "panelStyle", "detailsClassname", "variant"]);
    var classes = useStyles();
    var handleChange = onChange
        ? function (_, isExpanded) {
            return onChange(isExpanded);
        }
        : undefined;
    var contentClass = cx(classes.content, (_b = {},
        _b[classes.withMargin] = variant !== 'narrow',
        _b));
    return (React.createElement(Accordion, __assign({ style: panelStyle, classes: {
            expanded: classes.expanded,
            root: classes.root,
        }, expanded: expanded, elevation: elevation, square: square, onChange: handleChange }, rest),
        React.createElement(AccordionSummary, { classes: {
                root: classes.root,
                expanded: classes.expanded,
                content: contentClass,
            }, expandIcon: React.createElement(ExpandMoreIcon, { "data-test-locator": "Icon - ExpandMore" }) }, summary),
        React.createElement(AccordionDetails, { className: detailsClassname }, details)));
};
export default Expandable;
//# sourceMappingURL=index.js.map